import React from 'react';
import OutletDetailField from "./outlet-detail-field";
import {Col, Row} from "react-bootstrap";

const OutletDetails = ({details, id}) => (
  <div className="container-fluid">
    <Col md={6}>
      <Row>
        <OutletDetailField label="OutletID" data={id}/>
        <OutletDetailField label="Customer Number" data={details["customer-number"] || ""}/>
        <OutletDetailField label="Store Name" data={details["name"] || ""}/>
        <OutletDetailField label="Store address" data={

          <div>
            <div>{details['address-1'] || ""}</div>
            <div>{details['address-2'] || ""}</div>
            <div>{details['address-3'] || ""}</div>
            <div>{details['town'] || ""}</div>
            <div>{details['county'] || ""}</div>
            <div>{details['eircode'] || ""}</div>
          </div>
        }/>
        <OutletDetailField label="Passcode" data={details['passcode'] || ""}/>
        <OutletDetailField label="Reward Store" data={details['reward-store'] ? 'Yes' : 'No'}/>
      </Row>
    </Col>
    <Col md={6}>
      <Row>
        <OutletDetailField label="Updated store name" data={details['updated-name'] || ""}/>
        <OutletDetailField label="Updated store address" data={
          <div>
            <div>{details['updated-address-1'] || ""}</div>
            <div>{details['updated-address-2'] || ""}</div>
            <div>{details['updated-address-3'] || ""}</div>
            <div>{details['updated-town'] || ""}</div>
            <div>{details['updated-county'] || ""}</div>
            <div>{details['updated-eircode'] || ""}</div>
          </div>
        }/>
        {
          details['representative'] &&
          <OutletDetailField label="Imperial Tobacco Representative"
                             data={(details['representative'].rdr_first_name || "") + " " + (details['representative'].rdr_last_name || "")}/>
        }
      </Row>
    </Col>
  </div>
);

export default OutletDetails;


// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/outlet-details.jsx